module.exports = __webpack_public_path__ + "static/img/menu-cg.e907a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-cg.png
// module id = zP6t
// module chunks = 2